import { Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Account, AccountPayload } from '../models/account.model';
import { PlanSwitchResponse } from '../models';

@Injectable({ providedIn: 'root' })
export class AccountService {
  /**
   * Currently active / visible account
   */
  activeAccount = signal<Account>({} as Account);

  /**
   * All accounts
   */
  accounts = signal<Account[]>([]);

  constructor(private http: HttpClient) {}

  createAccount(accountPayload: AccountPayload): Observable<Account> {
    return this.http.post<Account>(`/account`, accountPayload);
  }

  getAccountById(accountId: string): Observable<Account> {
    return this.http.get<Account>(`/account/${accountId}`);
  }

  findAccountById(accountId: string): Account | undefined {
    return this.accounts().find((account) => account.id === accountId);
  }

  updateAccount(
    accountId: string,
    partialAccount: Partial<Account>,
  ): Observable<Account> {
    return this.http.patch<Account>(`/account/${accountId}`, partialAccount);
  }

  deleteAccount(accountId: string): Observable<Account> {
    return this.http.delete<Account>(`/account/${accountId}`);
  }

  getAccountsByProfileId(profileId: string): Observable<Account[]> {
    return this.http.get<Account[]>(`/accounts/${profileId}`);
  }

  getAccountByIdFromStore(accountId: string): Account | undefined {
    return this.accounts().find((account) => account.id === accountId);
  }

  switchToPicnic(accountId: string): Observable<PlanSwitchResponse> {
    return this.http.post<PlanSwitchResponse>(
      `/account/${accountId}/plan/free`,
      {},
    );
  }

  extendBreezePlan(accountId: string): Observable<PlanSwitchResponse> {
    return this.http.post<PlanSwitchResponse>(
      `/account/${accountId}/plan/extend`,
      {},
    );
  }
}
